import { EtxeApiSlugs, PropertyInvitationDetailsDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';

export class PublicPropertiesConnector {
  private slug = EtxeApiSlugs.PROPERTIES;

  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  getInvitationDetails(token: string): Observable<PropertyInvitationDetailsDto> {
    return this.apiCaller.getRequest<PropertyInvitationDetailsDto>(
      this.prefix,
      `${this.slug}/invitation?token=${encodeURIComponent(token)}`,
    );
  }
}
